module.exports = __webpack_public_path__ + "static/img/36中食.fc7197a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/36中食.jpg
// module id = HNUE
// module chunks = 1